import { ACTIVATE_MONEY_SAVE } from 'OK/MsEventBus';
import * as vanilla from 'OK/utils/vanilla';
import * as moneySave from 'OK/banners/moneySave';

/**
 * Баннер для подгрузки рекламы под леером, после его закрытия
 */
export class RareContentUnderLayerHandler {
    private isAnonym = false;
    private layerRenderFlag = '';
    private adBlockEnabled = false;

    bannerBlockIdsLogin = [
        'ViewportHeightAwareBanner',
        'ForthColumnTopBanner',
    ];

    bannerBlockIdsLoginAnonym = [
        'AnonymRightColumnAd',
        'AnonymLeftColumnAd',
    ];

    private updateBannerBlocks() {
        const blockIds = this.isAnonym
            ? this.bannerBlockIdsLoginAnonym
            : this.bannerBlockIdsLogin;
        const data = {
            [this.layerRenderFlag]: 'true',
        };
        return Promise.all(
            blockIds.map((blockId) =>
                vanilla.ajax({
                    url: `${OK.getCurrentStateLink()}&cmd=${blockId}`,
                    data
                })
            )
        ).then((results) => {
            results.forEach(vanilla.updateBlockModelCallback);
        })
    }

    private toggleHandler = (layerId: string, status: boolean) => {
        if (!status) {
            this.updateBannerBlocks()
                .then(() => {
                    if (this.adBlockEnabled) {
                        ACTIVATE_MONEY_SAVE.emit({});
                    }
                });
            OK.Layers.unsubscribeGlobal(this.toggleHandler);
        }
    }

    activate(element: HTMLElement) {
        this.isAnonym = element.dataset.isAnonym === 'true';
        this.layerRenderFlag = element.dataset.layerRenderFlag!;
        if (this.isAnonym) {
            OK.loader.use(["OKCustomJs"], () => {
                OK.Layers.subscribeGlobal(this.toggleHandler);
            });
        } else {
            (moneySave.detectAdBlock ? moneySave.detectAdBlock() : Promise.resolve(true))
                .then((result) => {
                    this.adBlockEnabled = result;
                    OK.loader.use(["OKCustomJs"], () => {
                        OK.Layers.subscribeGlobal(this.toggleHandler);
                    });
                })
        }
    }

    deactivate() {
        OK.Layers.unsubscribeGlobal(this.toggleHandler);
    }
}
